// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollRateProfileList_module__cVury","content":"PayrollRateProfileList_content__3OhFq"};